import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=51c891c2&scoped=true&"
import script from "./RuleTable.vue?vue&type=script&lang=js&"
export * from "./RuleTable.vue?vue&type=script&lang=js&"
import style0 from "./RuleTable.vue?vue&type=style&index=0&id=51c891c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c891c2",
  null
  
)

export default component.exports